import { Skeleton } from '@/components/ui'
import {
  type DocumentsSearchBlock,
  useLoadingSearch,
} from '@/modules/documents'
import { range } from '@/utils'
import { SearchResultItem } from './SearchResultItem'

interface SearchResultsProps {
  results: DocumentsSearchBlock[]
  selectedResult: DocumentsSearchBlock | null
  onSelect: (result: DocumentsSearchBlock) => void
  query: string
}

export const SearchResults = ({
  results,
  selectedResult,
  onSelect,
  query,
}: SearchResultsProps) => {
  const isLoading = useLoadingSearch()

  return (
    <div className="flex flex-col gap-3 p-4 bg-white border rounded-b overflow-y-auto flex-1">
      <div className="flex flex-col gap-1.5 overflow-y-auto flex-1">
        {isLoading &&
          range(5).map((k) => (
            <Skeleton key={k} className="h-16 w-full rounded-lg" />
          ))}

        {!isLoading &&
          results.map((result) => (
            <SearchResultItem
              key={result.id}
              result={result}
              isSelected={selectedResult?.id === result.id}
              onSelect={onSelect}
            />
          ))}

        {!isLoading && results.length === 0 && query.trim() && (
          <p className="text-lg text-muted-foreground text-center py-8">
            No results found.
          </p>
        )}
      </div>
    </div>
  )
}
